// CookieConsentBanner.jsx
import { X } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { useConsent } from '../consent_banner/ConsentContext'; 

const CookieConsentBanner = () => {
  const { consentStatus, updateConsent } = useConsent();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (consentStatus === 'pending') {
      setIsVisible(true);
    }
  }, [consentStatus]);

  const handleAcceptAll = () => {
    updateConsent('all');
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    updateConsent('necessary');
    setIsVisible(false);
  };

  const handleCustomize = () => {
    // You can implement a modal or redirect to a cookie preferences page
    console.log('Open cookie preferences');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-7xl mx-auto p-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between">
          <div className="flex-1 pr-4 mb-4 sm:mb-0">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">We value your privacy</h2>
            <p className="text-gray-600">
              We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies. We also use essential cookies to ensure our website works properly.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <button
              onClick={handleCustomize}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
            >
              Customize
            </button>
            <button
              onClick={handleAcceptNecessary}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
            >
              Accept Necessary
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
            >
              Accept All
            </button>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
            aria-label="Close banner"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;